import React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AdminPage from "components/template/adminpage";
import EmployeeActivities from "components/employee-activities";
import { employeeActivityApi } from "lib/employee-activities";
import { addNotice } from "store/actions/notices";

function EmployeeActivitiesPage({ notify }) {
  return (
    <React.Fragment>
      <Helmet>
        <title>Le mie attività</title>
      </Helmet>
      <AdminPage title="Le mie attività">
        <EmployeeActivities addNotice={notify} api={employeeActivityApi} mode="employee" />
      </AdminPage>
    </React.Fragment>
  );
}

export { EmployeeActivitiesPage };

const mapDispatchToProps = (dispatch) => {
  return {
    notify: bindActionCreators(addNotice, dispatch),
  };
};

export default connect(null, mapDispatchToProps)(EmployeeActivitiesPage);
